import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtEur = (v, lang = "it") =>
  new Intl.NumberFormat(lang === "it" ? "it-IT" : "en-GB", {
    style: "currency", currency: "EUR", maximumFractionDigits: 0,
  }).format(v || 0);

export const fmtNum = (v, dec = 2) => (v == null ? "—" : Number(v).toFixed(dec));

export const fmtThousands = (v, lang = "it") => {
  const n = Math.round(Math.abs(v));
  const sep = lang === "it" ? "." : ",";
  const s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  return `${v < 0 ? "-" : ""}${s}`;
};
